import { apiClientWithRefreshToken } from "@/api/apiClient";
import { GenerateOnboardLinkSchema } from "@/v2/schema/supplier";

export default async function CreateSupplierOnboardLink(
    data: GenerateOnboardLinkSchema,
): Promise<{
    Token: string;
}> {
    const res = await apiClientWithRefreshToken({
        url: "/vendors/onboard",
        method: "POST",
        data,
    });

    return res.data;
}
